export type RecursiveKeyOf<TObj extends object> = {
  [TKey in keyof TObj & (string)]: TObj[TKey] extends object
    ? `${TKey}` | `${TKey}.${RecursiveKeyOf<TObj[TKey]>}`
    : `${TKey}`;
}[keyof TObj & string];

export function getValueByPath(obj: any, path: string): string | undefined {
  return path.split('.').reduce((acc, part) => acc?.[part], obj);
}

export function interpolate(template: string, values: Record<string, string | number>): string {
  return template.replace(/{(.*?)}/g, (_, key) => values[key] !== undefined ? String(values[key]) : `{${key}}`);
}